import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6fe3efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href", "fill"]


  import { defineComponent } from 'vue';
  const __default__ = defineComponent({
    name: 'BaseIcon',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  setup(__props) {

const props = __props

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(['base-icon', 'base-icon-' + __props.name])
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${props.name}`,
      fill: __props.color
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})